import mapLocale from './mapLocale'

export const schemes = {
  normalDay: 'normal.day',
  normalDayGray: 'normal.day.gray',
  reducedDay: 'reduced.day'
}

export const defaultOptions = {
  subdomains: '1234',
  attribution: `© 1987–${(new Date()).getFullYear()} HERE |
<a target="_blank" href="https://legal.here.com/en/terms/serviceterms/us">Terms of use</a>`,
  minZoom: 2,
  maxZoom: 20
}

const defaultParams = {
  apiKey: process.env.VUE_APP_HERE_API_KEY,
  ppi: 72 // mobile: 250
}

export function queryString(params) {
  const esc = encodeURIComponent
  return Object.keys(params)
    .map(key => `${esc(key)}=${esc(params[key])}`)
    .join('&')
}

export default function makeTileLayerUrl({
  scheme = schemes.normalDay,
  tileType = 'maptile',
  resolution = 256,
  format = 'png8',
  params = {}
} = {}) {
  if ('lg' in params) {
    // eslint-disable-next-line no-param-reassign
    params.lg = mapLocale(params.lg)
  }

  // eslint-disable-next-line vue/max-len
  return `https://{s}.base.maps.ls.hereapi.com/maptile/2.1/${tileType}/newest/${scheme}/{z}/{x}/{y}/${resolution}/${format}?${queryString({ ...defaultParams, ...params })}`
}
